export const FileTypes_Text = `<svg title="FileTypes_Text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
<path d="M3 3C3 1.34315 4.34315 0 6 0H15L21 6V21C21 22.6569 19.6569 24 18 24H6C4.34315 24 3 22.6569 3 21V3Z" fill="#D4EFFF"/>
<path d="M12 12.75H18V14.25H12V12.75Z" fill="#0051D5"/>
<path d="M13 10H18V11.5H13V10Z" fill="#0051D5"/>
<path d="M11 15.5H18V17H11V15.5Z" fill="#0051D5"/>
<path opacity="0.4" d="M15 0L21 6H17C15.8954 6 15 5.10457 15 4V0Z" fill="#0051D5"/>
<path d="M6 11.3253V10H11V11.3253H9.26563V17H7.69744V11.3253H6Z" fill="#0051D5"/>
</svg>`;